import * as S from "./styles.ts";
import useBreakpoint from "@/lib/helpers/useBreakpoint.ts";

const Th = ({ children }) => (
  <S.Th>
    <div>
      <p>{children}</p>
      <span>Domains</span>
    </div>
  </S.Th>
);

const THeader = () => {
  const { check: isMd } = useBreakpoint("sm");
  return (
    <S.Thead>
      <tr>
        {isMd && <th />}
        <Th>1-4</Th>
        <Th>5-25</Th>
        <Th>25+</Th>
      </tr>
    </S.Thead>
  );
};

export default THeader;
